import { Phone, Mail } from "lucide-react";
import { propertyData } from "../mock";

export const SimpleFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white  py-2 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-amber-500/10 to-yellow-600/10 rounded-full blur-3xl animate-float"></div>
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-gradient-to-br from-yellow-500/10 to-amber-600/10 rounded-full blur-3xl animate-float-delayed"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-1 gap-12 mb-12">
            {/* Brand */}
            {/* <div className="transform hover:scale-105 transition-transform duration-500">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-yellow-600 rounded-lg flex items-center justify-center mr-3 shadow-lg shadow-amber-500/30">
                  <span className="text-white font-bold text-2xl">R</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-amber-300">
                    {propertyData.name}
                  </h3>
                </div>
              </div>
              <p className="text-amber-200 text-lg mb-4">
                {propertyData.tagline}
              </p>
              <p className="text-gray-300 mb-3 hover:text-white transition-colors duration-300">
                {propertyData.location}
              </p>
              <p className="text-sm text-amber-200 bg-amber-500/10 px-4 py-2 rounded-lg inline-block">
                {propertyData.reraNumber}
              </p>
            </div> */}

            {/* Contact */}
            <div className="transform hover:scale-105 transition-transform duration-500">
              <p style={{fontSize:'small', marginBottom:'0.5rem'}}>
                This website is managed by an authorized marketing partner of
                MSN Realty and is not the official website of MSN or One by MSN.
                All logos, images, and content used on this site are the
                exclusive property of MSN and are used here with due
                acknowledgment for marketing purposes only.
              </p>

              <p style={{fontSize:'small',marginBottom:'0.5rem'}}>
                The information presented on this website is intended solely for
                general guidance and informational purposes. It does not
                constitute a legal offer, commitment, or assurance to provide
                any services or deliverables. All pricing, availability, and
                other project-related details are subject to change without
                prior notice at the sole discretion of the developer.
              </p>

              <p style={{fontSize:'small',marginBottom:'0.5rem'}}>
                Visuals such as renderings, floor plans, and images are artistic
                impressions and are for representational purposes only. Final
                specifications and features may vary.
              </p>

              <p style={{fontSize:'small',marginBottom:'0.5rem'}}>
                By providing your contact details on this website, you authorize
                us to send project-related updates, offers, or communication.
              </p>

              <p style={{fontSize:'small'}}>
                Your privacy is important to us, and all shared data is handled
                with the utmost confidentiality and in accordance with
                applicable data protection laws.
              </p>
              {/* <h4 className="text-xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-400">Contact Us</h4>
              <div className="space-y-4 text-gray-300">
                <div className="flex items-center group hover:translate-x-2 transition-transform duration-300">
                  <div className="w-10 h-10 bg-gradient-to-br from-amber-500/20 to-yellow-600/20 rounded-full flex items-center justify-center mr-3 group-hover:from-amber-500/40 group-hover:to-yellow-600/40 transition-all duration-300">
                    <Phone className="w-5 h-5 text-amber-400" />
                  </div>
                  <span className="group-hover:text-white transition-colors duration-300">+91 98765 43210</span>
                </div>
                <div className="flex items-center group hover:translate-x-2 transition-transform duration-300">
                  <div className="w-10 h-10 bg-gradient-to-br from-amber-500/20 to-yellow-600/20 rounded-full flex items-center justify-center mr-3 group-hover:from-amber-500/40 group-hover:to-yellow-600/40 transition-all duration-300">
                    <Mail className="w-5 h-5 text-amber-400" />
                  </div>
                  <span className="group-hover:text-white transition-colors duration-300">info@royalheights.com</span>
                </div>
              </div> */}
            </div>

            {/* Location */}
            {/* <div className="transform hover:scale-105 transition-transform duration-500">
              <h4 className="text-xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-400">
                Location
              </h4>
              
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};
